import React, { FC, useEffect, useState } from 'react';
import API from 'core/Api';
import { IResponseData } from 'types/api';
import { useActiveClientContext } from 'store/active-client';
import { IScenario } from './types';
import InnerWrapper from '../InnerWrapper';
import FormTable from './components/FormTable';

const Screen: FC = () => {
  const [data, setData] = useState<IResponseData<IScenario> | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const { client } = useActiveClientContext();

  const fetchEntity = async () => {
    setIsLoading(true);
    try {
      const response = await API.get<IResponseData<IScenario>>('category-permissions/dropdown-options');
      setData(response.data);
    } catch (err) {
      setError(err as Error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEntity();
  }, [client]);

  return (
    <InnerWrapper
      isLoading={isLoading}
      error={error}
    >
      {data ? <FormTable data={data} /> : <></>}
    </InnerWrapper>
  );
};

export default Screen;
